export default __webpack_public_path__ + "static/media/select-operator-icon-green.87ad6a66.svg";